export default __webpack_public_path__ + "24433930b817f9dd182a68b1c5b12725.png";